import { Button, Form, Modal } from "antd"
import { Store } from "antd/lib/form/interface"
import React from "react"
import { useTranslation } from "react-i18next"
import InboxFilterForm from "Components/forms/inboxFilter.form"

interface InboxFilterModalInterface {
    isVisible: boolean
    onCancel: (state: false) => void
    onSubmit: (dashboardFilterData: any) => Promise<void>
}
const InboxFilterModal: React.FC<InboxFilterModalInterface> = ({ isVisible, onCancel, onSubmit }) => {
    const { t } = useTranslation()
    const [formInstance] = Form.useForm()

    const handleSubmit = async (values: Store) => {
        if (values.minUploadDate) values.minUploadDate.startOf("day")
        if (values.maxUploadDate) values.maxUploadDate.endOf("day")

        handleHide()
        await onSubmit(values)
    }

    const handleHide = () => {
        onCancel(false)
    }

    return (
        <Modal
            title={t("action:filter")}
            visible={isVisible}
            maskClosable={false}
            onOk={formInstance.submit}
            onCancel={handleHide}
            keyboard
            destroyOnClose
            footer={[
                <Button
                    key="back"
                    onClick={() => {
                        formInstance.resetFields()
                        onCancel(false)
                    }}
                >
                    {t("action:cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        formInstance.submit()
                    }}
                >
                    {t("action:apply_filter")}
                </Button>,
            ]}
        >
            <InboxFilterForm formInstance={formInstance} onSubmit={handleSubmit} />
        </Modal>
    )
}

export default InboxFilterModal
